module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P3",
    attrs: {
      "id": "auto_bookmark_toc_2"
    }
  }, [_c('span', [_vm._v("Kraken My Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }), _vm._v(" "), _c('p', {
    staticClass: "P5"
  }, [_vm._v("Von K.L. Hiers")]), _vm._v(" "), _c('p', {
    staticClass: "P5"
  }, [_vm._v("Ein Kraken-Krimi der anderen Dimension")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("Es passt einfach alles zusammen: als Ted die Liebe seines Lebens kennenlernt, ist er von oben bis unten mit dem Blut eines Mordopfers bedeckt.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("Ted Sturm arbeitet für ein Bestattungsunternehmen. Er hat ein loses Mundwerk, ein großes Herz und die zweifelhafte Gabe, mit Toten kommunizieren zu können. Unglücklicherweise sind Tote keine guten Freunde, und sein einziger lebender Freund, mit dem er auch die Wohnung teilt, hat gerade eine streunende Katze aufgenommen, die Ted das Leben zur Hölle macht. Und diese Katze – eigentlich ein Kater – hat es in sich. So kommt es, dass Ted sich plötzlich in einer anderen Dimension wiederfindet. Auf einer Leiche.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("Ted wird des Mordes angeklagt und sein einziger Verbündeter in dieser merkwürdigen Welt voller magischer Wesen und Unwesen ist König Grell, ein sarkastischer, geiler, katzenartiger Unsterblicher mit beeindruckenden Fähigkeiten. Und einer beeindruckenden Anatomie. Die beiden werden in eine kosmische Verschwörung verwickelt, umgeben von gefährlichen Feinden. Mit Teds spezieller Begabung und Grells Magie müssen sie versuchen, der Sache auf den Grund zu gehen, um Teds Leben zu retten. Es gibt da nur ein Problem: Ted muss Grells unzweideutigen Avancen widerstehen. Und er ist sich nicht sicher, ob er das überhaupt will.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0